// AI Instructions textarea panel — extracted from RosterDetail.jsx iter34.
import { Sparkles } from "lucide-react";

const AIInstructionsPanel = ({ aiInstructions, setAiInstructions, isPublished }) => {
  if (isPublished) return null;

  return (
    <div className="bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 p-4" data-testid="ai-instructions-section">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-[#002FA7] dark:text-blue-400" />
          <h3 className="text-sm font-medium text-zinc-900 dark:text-zinc-100">AI Instructions</h3>
        </div>
        <p className="text-xs text-zinc-500 dark:text-zinc-400">Optional — applied during AI polish step</p>
      </div>
      <textarea
        value={aiInstructions}
        onChange={(e) => setAiInstructions(e.target.value)}
        placeholder="e.g., Prefer to schedule Alice and Bob together; avoid placing new hires on Sunday morning shifts; favour 4-day work blocks for full-time staff..."
        className="w-full text-sm p-3 border border-zinc-200 dark:border-zinc-800 rounded bg-white dark:bg-zinc-900 text-zinc-900 dark:text-zinc-100 placeholder:text-zinc-400 dark:placeholder:text-zinc-600 focus:outline-none focus:ring-1 focus:ring-[#002FA7] resize-y min-h-[80px]"
        maxLength={1500}
        data-testid="ai-instructions-textarea"
      />
      <p className="text-[11px] text-zinc-400 dark:text-zinc-500 mt-1">
        {aiInstructions.length}/1500 characters · saved when you generate or fix the roster
      </p>
    </div>
  );
};

export default AIInstructionsPanel;
